import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", ";\n        font-weight: ", ";\n        line-height: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
export var typography = function typography() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body2';
  return function (_ref) {
    var typography = _ref.theme.typography;
    var fontFamily = typography.fontFamily,
        _typography$variant = typography[variant],
        fontSize = _typography$variant.fontSize,
        fontWeight = _typography$variant.fontWeight,
        lineHeight = _typography$variant.lineHeight;
    return css(_templateObject(), fontFamily, fontSize, fontWeight, lineHeight);
  };
};